import isEqual from 'lodash/isEqual'
import memoize from 'lodash/memoize'
import * as Sentry from '@sentry/react'
const resquestMapping = new Map()

let timerId: any = 0
const timeout = 400
const blankList: string[] = ['/api/company/open/forwarding/action', '/shelves/taobao/v3/queryClientToken']
const checkExprie = () => {
    const doTask = () => {
        function fn() {
            timerId && clearTimeout(timerId)
            const nowTime = new Date().valueOf()

            for (let key of resquestMapping.keys()) {
                const target = resquestMapping.get(key)

                const { exprieDate } = target
                if (exprieDate < nowTime) {
                    resquestMapping.delete(key)
                }
            }
            if (resquestMapping.size) {
                timerId = setTimeout(fn, timeout)
            }
        }

        timerId = setTimeout(fn, timeout)
    }
    doTask()
}
const isDev = PROJECT_CONFIG.mode === 'dev'
const isTest = PROJECT_CONFIG.mode === 'test'

const inBlankList = memoize((url: string) => {
    const temp = blankList.find(item => url.endsWith(item))

    return !!temp
})
export const repeatReqChecker = (url: string, options: any) => {
    if (isTest || (isDev && !inBlankList(url))) {
        const target = resquestMapping.get(url)
        if (target) {
            const { exprieDate, args, data } = target
            if (exprieDate > new Date().valueOf() && isEqual(options?.params, args) && isEqual(options?.data, data)) {
                if (isTest) {
                    Sentry.setExtra('extra', {
                        params: JSON.stringify(options?.params),
                        data: JSON.stringify(options?.data),
                    })
                    Sentry.captureException(new Error(`重复请求：url:${url}`))

                    return
                }
                console.error(`重复请求： url:${url} 参数: ${JSON.stringify(target)}`)
            }
        }

        if (!timerId) {
            checkExprie()
        }

        resquestMapping.set(url, {
            exprieDate: new Date().valueOf() + timeout,
            args: options?.params,
            data: options?.data,
        })
    }

    return {
        url,
        options,
    }
}
